import { Injectable, inject } from '@angular/core';

import { MenuCounters, MenuCountersProvider, MenuSection } from '@frontend/vanilla/core';

import { InboxService } from './services/inbox.service';

@Injectable({ providedIn: 'root' })
export class InboxMenuCountersProvider implements MenuCountersProvider {
    private inboxService = inject(InboxService);

    get order() {
        return 10;
    }

    setCounters(counters: MenuCounters): void {
        const value = this.inboxService.getCount() || null;

        counters.set(MenuSection.Menu, 'myinbox', value);
        counters.set(MenuSection.Header, 'inbox', value);
    }
}
